/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';
import { IPermitToWorkRequest } from '../forms/permit-to-work.form';
import { IPermitToWorkListQuery } from '../models/permit-to-work-list-result.model';
import {
  IFinishPermitToWorkCommand,
  IPerformPermitToolboxTalkRequest,
  IPermitDocumentationChanges,
  IPermitInProgressChanges,
  IProlongPermitToWorkRequest,
} from '../models/permit-to-work-workflow.model';

export class LoadPermitToWorks {
  static readonly type = '[Permit To Work] Load';
  constructor(public query?: IPermitToWorkListQuery) {}
}

export class GetPermitToWorkById {
  static readonly type = '[Permit To Work] Get By Id';
  constructor(public id: string) {}
}

export class GetProlongedPermitToWork {
  static readonly type = '[Permit To Work] Get Prolonged';
  constructor(
    public id: string,
    public prolongedVersionId: string
  ) {}
}

export class LoadPermitToWorkNotifications {
  static readonly type = '[Permit To Work] Load Notifications';
}

export class LoadPermitToWorkOptions {
  static readonly type = '[Permit To Work] Load Options';
}

export class LoadPermitToWorkLog {
  static readonly type = '[Permit To Work] Load Log';
  constructor(
    public id: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class ClearPermitToWorkLog {
  static readonly type = '[Permit To Work] Clear Log';
}

export class CreatePermitToWork {
  static readonly type = '[Permit To Work] Create';
  constructor(public permit: IPermitToWorkRequest) {}
}

export class UpdatePermitToWorkDraft {
  static readonly type = '[Permit To Work] Update Draft';
  constructor(
    public id: string,
    public permit: IPermitToWorkRequest
  ) {}
}

export class SavePermitToWorkAndSendForApproval {
  static readonly type = '[Permit To Work] Save And Send For Approval';
  constructor(public permit: IPermitToWorkRequest) {}
}

export class ApprovePermitToWorkNow {
  static readonly type = '[Permit To Work] Approve Now';
  constructor(
    public id: string | null,
    public permit: IPermitToWorkRequest
  ) {}
}

export class UpdatePermitToWorkAndSendForApproval {
  static readonly type = '[Permit To Work] Update And Send For Approval';
  constructor(
    public id: string,
    public permit: IPermitToWorkRequest
  ) {}
}

export class SubmitPermitToWork {
  static readonly type = '[Permit To Work] Submit';
  constructor(public id: string) {}
}

export class ReviewPermitToWork {
  static readonly type = '[Permit To Work] Review';
  constructor(
    public id: string,
    public changes: IPermitToWorkRequest
  ) {}
}

export class ApprovePermitToWork {
  static readonly type = '[Permit To Work] Approve';
  constructor(
    public id: string,
    public comment?: string | null
  ) {}
}

export class SavePermitToWorkAndApprove {
  static readonly type = '[Permit To Work] Save And Approve';
  constructor(
    public id: string,
    public changes: IPermitToWorkRequest
  ) {}
}

export class UpdateApprovedPermitToWork {
  static readonly type = '[Permit To Work] Update Approved';
  constructor(
    public id: string,
    public changes: IPermitDocumentationChanges
  ) {}
}

export class UpdateInProgressPermitToWork {
  static readonly type = '[Permit To Work] Update In Progress';
  constructor(
    public id: string,
    public changes: IPermitInProgressChanges
  ) {}
}

export class UpdateFinishedPermitToWork {
  static readonly type = '[Permit To Work] Update Finished';
  constructor(
    public id: string,
    public changes: IPermitDocumentationChanges
  ) {}
}

export class RejectPermitToWork {
  static readonly type = '[Permit To Work] Reject';
  constructor(
    public id: string,
    public comment?: string | null
  ) {}
}

export class PerformPermitToolboxTalk {
  static readonly type = '[Permit To Work] Perform Toolbox Talk';
  constructor(
    public id: string,
    public toolboxTalk: IPerformPermitToolboxTalkRequest
  ) {}
}

export class SetPermitToWorkInProgress {
  static readonly type = '[Permit To Work] Set In Progress';
  constructor(
    public id: string,
    public startTime?: string | null
  ) {}
}

export class FinishPermitToWork {
  static readonly type = '[Permit To Work] Finish';
  constructor(
    public id: string,
    public command: IFinishPermitToWorkCommand
  ) {}
}

export class ClosePermitToWork {
  static readonly type = '[Permit To Work] Close';
  constructor(public id: string) {}
}

export class CopyPermitToWorkToDraft {
  static readonly type = '[Permit To Work] Copy To Draft';
  createdId = '';
  constructor(public id: string) {}
}

export class ProlongPermitToWork {
  static readonly type = '[Permit To Work] Prolong';
  constructor(
    public id: string,
    public permit: IProlongPermitToWorkRequest
  ) {}
}

export class LoadPermitToWorkProlongContext {
  static readonly type = '[Permit To Work] Load Prolong Context';
  constructor(public id: string) {}
}

export class LoadPermitToWorkCreateContext {
  static readonly type = '[Permit To Work] Load Create Context';
}

export class DeletePermitToWork {
  static readonly type = '[Permit To Work] Delete';
  constructor(public id: string) {}
}

export class ClearCurrentPermitToWork {
  static readonly type = '[Permit To Work] Clear Current';
}
